import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';
import { AccordionWithButton } from 'UIPackage/MainModule/components/AccordionWithButton';

import styles from './KnmListByPlanRequirementsList.module.scss';

export const KnmListByPlanReasonsList = ({ row }: ITableRenderCell<IKnmRaw>) => {
  return (
    <>
      {row.reasonsList &&
        row.reasonsList.length > 0 &&
        (row.reasonsList.length > 1 ? (
          <>
            <div className={styles.MultiListTitle}>{row.reasonsList[0]?.text}</div>
            <div className={styles.MultiListDate}>{row.reasonsList[0]?.date}</div>
            <AccordionWithButton
              content={row.reasonsList
                .filter((item, index) => item && index > 0)
                .map(item => (
                  <>
                    <div className={styles.MultiListTitle}>{item?.text}</div>
                    <div className={styles.MultiListDate}>{item?.date}</div>
                  </>
                ))}
            />
          </>
        ) : (
          <>
            <div className={styles.MultiListTitle}>{row.reasonsList[0]?.text}</div>
            <div className={styles.MultiListDate}>{row.reasonsList[0]?.date}</div>
          </>
        ))}
    </>
  );
};
